export default {
  apiGateway: {
    REGION: 'ap-northeast-2',
    URL: 'https://of1gfdtjtl.execute-api.ap-northeast-2.amazonaws.com/dev',
  },
  cognito: {
    REGION: 'ap-northeast-2',
    USER_POOL_ID: 'ap-northeast-2_xrx6oCVvN',
    APP_CLIENT_ID: '4j8hro29oamuv40oajstsfmd27',
    IDENTITY_POOL_ID: 'ap-northeast-2:c3a14f74-37b0-4d73-9a1e-0d52eac34b83',
  },
  web: {
    YOUTUBE_URL: 'https://www.googleapis.com/youtube/v3/channels?part=snippet%2CcontentDetails%2Cstatistics',
    API_KEY: 'AIzaSyByw-AT74S21oNVkDarQB_-jgk593vEn6I',
    //API_KEY: 'AIzaSyA97aEO404YPziGp0nXdhaSbb_C6Taxsrw',
    //API_KEY: 'AIzaSyDIQSBR71u9miSjlz0FKNXULmubiMD_wP8',
    //API_KEY: 'AIzaSyA4RaLXyivDmqXST5WkYu9QFXHR7gR7hNU',
    JWT_SECRET: 'Hell0WhatAW0nderfulW0rld!!',
    KNHHOME_URL: 'https://knh4cs.s3.ap-northeast-2.amazonaws.com/static/index.html',
  },
};
